var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCommentRed = function SvgCommentRed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF85C0",
    d: "M14.8 4.5H5.2c-.66 0-1.2.54-1.2 1.2v7.2c0 .66.54 1.2 1.2 1.2h7.986a1 1 0 0 1 .707.293l1.253 1.253a.5.5 0 0 0 .854-.353V5.7c0-.66-.54-1.2-1.2-1.2Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCommentRed);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjggNC41SDUuMkM0LjU0IDQuNSA0IDUuMDQgNCA1LjdWMTIuOUM0IDEzLjU2IDQuNTQgMTQuMSA1LjIgMTQuMUgxMy4xODU4QzEzLjQ1MSAxNC4xIDEzLjcwNTQgMTQuMjA1NCAxMy44OTI5IDE0LjM5MjlMMTUuMTQ2NCAxNS42NDY0QzE1LjQ2MTQgMTUuOTYxNCAxNiAxNS43MzgzIDE2IDE1LjI5MjlWNS43QzE2IDUuMDQgMTUuNDYgNC41IDE0LjggNC41WiIgZmlsbD0iI0ZGODVDMCIvPgo8L3N2Zz4K";